import Cookies from 'js-cookie';

export const EXPERIMENT_PREFIX = 'signup';

export const getExperimentInfo = (basePrefix = EXPERIMENT_PREFIX): string => {
  const allCookies = Cookies.get();

  let experimentInfo: string = basePrefix;

  for (const [key, value] of Object.entries(allCookies)) {
    if (/^_vis_opt_exp_.*_combi$/.test(key)) {
      const experienceValue = key.replace(/(^_vis_opt_exp_+|_combi+$)/gm, '');

      experimentInfo += ` - experiment ${experienceValue} v${value}`;
    }
  }

  return experimentInfo;
};
